"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.StyledButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var StyledButton = (0, _styledComponents.default)('button').withConfig({
  displayName: "Button__StyledButton",
  componentId: "y98fps-0"
})({
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  ':disabled': {
    pointerEvents: 'none',
    boxShadow: 'none',
    cursor: 'not-allowed'
  }
}, (0, _styledSystem.variant)({
  prop: 'buttonType',
  variants: {
    default: {
      color: 'coco',
      borderRadius: 1,
      backgroundColor: 'rambutan',
      ':hover': {
        backgroundColor: 'variants.rambutan.light'
      },
      ':active': {
        backgroundColor: 'variants.rambutan.dark'
      },
      ':disabled': {
        backgroundColor: 'langsat',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'guama'
        }
      }
    },
    primary: {
      color: 'coco',
      borderRadius: 1,
      backgroundColor: 'quandog',
      ':hover': {
        backgroundColor: 'variants.quandog.light'
      },
      ':active': {
        backgroundColor: 'variants.quandog.dark'
      },
      ':disabled': {
        backgroundColor: 'langsat',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'guama'
        }
      }
    },
    secondary: {
      color: 'coco',
      borderRadius: 1,
      backgroundColor: 'guijarro',
      ':hover': {
        backgroundColor: 'castana'
      },
      ':active': {
        backgroundColor: 'sonar'
      },
      ':disabled': {
        backgroundColor: 'langsat',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'guama'
        }
      }
    },
    text: {
      color: 'sonar',
      backgroundColor: 'transparent'
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'rounded',
  variants: {
    true: {
      borderRadius: 7
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    tiny: {
      paddingX: [3, 3, 3],
      paddingY: [1, 1, 1]
    },
    small: {
      paddingX: [3, 3, 3],
      paddingY: [1, 1, 1]
    },
    medium: {
      paddingX: [4, 4, 4],
      paddingY: [3, 3, 3]
    },
    large: {
      paddingX: [4, 4, 5],
      paddingY: [3, 3, 4]
    },
    huge: {
      paddingX: [5, 5, 6],
      paddingY: [4, 4, 5]
    },
    none: {
      paddingX: [0, 0, 0],
      paddingY: [0, 0, 0]
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'hollow',
  variants: {
    default: {
      boxShadow: '#f02d00 0px 0px 0px 2px inset',
      backgroundColor: 'transparent',
      ':hover': {
        backgroundColor: 'transparent',
        boxShadow: '#CA2600 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'variants.rambutan.light'
        }
      },
      ':active': {
        backgroundColor: 'transparent',
        boxShadow: '#A11E00 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'variants.rambutan.dark'
        }
      },
      ':disabled': {
        backgroundColor: 'transparent',
        boxShadow: '#d9d9d9 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'guama'
        }
      }
    },
    primary: {
      backgroundColor: 'transparent',
      boxShadow: '#00B2BD 0px 0px 0px 2px inset',
      ':hover': {
        backgroundColor: 'transparent',
        boxShadow: '#008F98 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'variants.quandog.light'
        }
      },
      ':active': {
        backgroundColor: 'transparent',
        boxShadow: '#007076 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'variants.quandog.dark'
        }
      },
      ':disabled': {
        backgroundColor: 'transparent',
        boxShadow: '#d9d9d9 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'guama'
        }
      }
    },
    secondary: {
      backgroundColor: 'transparent',
      boxShadow: '#e5e5e5 0px 0px 0px 2px inset',
      ':hover': {
        backgroundColor: 'transparent',
        boxShadow: '#B0B0B0 0px 0px 0px 2px inset'
      },
      ':active': {
        backgroundColor: 'transparent',
        boxShadow: '#848484 0px 0px 0px 2px inset'
      },
      ':disabled': {
        backgroundColor: 'transparent',
        boxShadow: '#d9d9d9 0px 0px 0px 2px inset',
        'h1, h2, h3, h4, h5, h6, p, span, i': {
          color: 'guama'
        }
      }
    }
  }
}), _styledSystem.border, _styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.textStyle, _styledSystem.shadow, _styledSystem.layout);
exports.StyledButton = StyledButton;

var Button = function Button(_ref) {
  var children = _ref.children,
      action = _ref.action,
      ariaLabel = _ref.ariaLabel,
      forwardRef = _ref.forwardRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "action", "ariaLabel", "forwardRef"]);
  return _react.default.createElement(StyledButton, (0, _extends2.default)({
    ref: forwardRef,
    onClick: action,
    "aria-label": ariaLabel,
    role: "button"
  }, props), children);
};

exports.Button = Button;
Button.defaultProps = {
  disabled: false,
  buttonType: 'default',
  size: 'medium',
  rounded: false,
  ariaLabel: '',
  hollow: null,
  type: 'button',
  forwardRef: function forwardRef() {}
};